import Icon from './Icon';

const Spinner = () => {
  return <Icon type="faSpinner" className="animate-spin" />;
};

export default Spinner;
